export default __webpack_public_path__ + "static/newsletter-background-fc4d62582c68aefdec128a8a45b8412c.mp4";